import axios from 'axios';

export default async function removeResponsibles({
  accessToken,
  companyGroupId,
  responsible_ids,
  setTokenLikeExpired,
}) {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_COMPANY_GROUPS_API_URL}/responsible/remove/${companyGroupId}`,
      { responsible_ids },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return data;
  } catch (err) {
    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();

    return err;
  }
}
